import React, { useCallback, useEffect, useState } from "react"
import { Alert, Badge, Button, Card, Spinner, Table } from "react-bootstrap"
import { admin } from "../../config/apiEndpoints"
import axiosProvider from "../../lib/AxiosProvider"

const formatMinorUnits = (value) => {
  try {
    const amount = window.BigInt(value ?? "0")
    const rupees = (amount / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    const paise = (amount % 100n).toString().padStart(2, "0")
    return `₹${rupees}.${paise}`
  } catch {
    return "₹0.00"
  }
}

const badges = { COMPLETED: "success", PENDING: "warning", FAILED: "danger", CANCELLED: "secondary" }

const VendorWalletTransactions = ({ refreshKey = 0 }) => {
  const [transactions, setTransactions] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")
  const [retryKey, setRetryKey] = useState(0)

  const loadTransactions = useCallback(async () => {
    setLoading(true)
    setError("")
    try {
      const response = await axiosProvider({
        method: "GET",
        endpoint: admin.fleetVendorWalletTransactions,
        params: { page: "1", limit: "20" },
      })
      if (response?.data?.code !== 200) {
        throw new Error(response?.data?.message || "Unable to load wallet transactions")
      }
      setTransactions(response.data.data || [])
    } catch (requestError) {
      setError(requestError?.message || "Unable to load wallet transactions")
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => { loadTransactions() }, [loadTransactions, refreshKey, retryKey])

  return (
    <Card className="mt-3">
      <Card.Body>
        <h3 className="card_title mb-3">Wallet Transaction History</h3>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center gap-2 py-4 text-body-secondary"><Spinner animation="border" size="sm" /> Loading wallet transactions...</div>
        ) : error ? (
          <Alert variant="danger" className="mb-0 d-flex align-items-center justify-content-between gap-3"><span>{error}</span><Button size="sm" variant="outline-danger" onClick={() => setRetryKey((key) => key + 1)}>Retry</Button></Alert>
        ) : transactions.length ? (
          <Table className="rounded mb-0 table-striped" responsive="md">
            <thead><tr><th>Reference</th><th>Type</th><th>Amount</th><th>Payment Method</th><th>Status</th><th>Date</th></tr></thead>
            <tbody>{transactions.map((transaction) => <tr key={transaction.id}>
              <td className="text-break">{transaction.reference || "—"}</td>
              <td>{transaction.transaction_type || "—"}</td>
              <td>{formatMinorUnits(transaction.amount_minor)}</td>
              <td>{transaction.payment_method || "—"}</td>
              <td><Badge bg={badges[transaction.status] || "secondary"}>{transaction.status || "—"}</Badge></td>
              <td>{transaction.createdAt ? new Date(transaction.createdAt).toLocaleString() : "—"}</td>
            </tr>)}</tbody>
          </Table>
        ) : <p className="mb-0 py-4 text-center text-body-secondary">No wallet transactions found.</p>}
      </Card.Body>
    </Card>
  )
}

export default VendorWalletTransactions
